import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useNavigate } from 'react-router';
//

// ----------------------------------------------------------------------

export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow }) {
    const { first_name, last_name, avatarUrl, company, role, status, email, phoneNumber } = row;
    const navigate = useNavigate();

    const confirm = useBoolean();

    const quickEdit = useBoolean();

    const popover = usePopover();

    return (
        <>
            <TableRow hover selected={ selected }>
                <TableCell padding="checkbox">
                    <Checkbox checked={ selected } onClick={ onSelectRow } />
                </TableCell>

                <TableCell sx={ { display: 'flex', alignItems: 'center' } }>
                    <Avatar alt={ first_name } src={ avatarUrl } sx={ { mr: 2 } } />

                    <ListItemText
                        primary={ `${first_name} ${last_name}` }
                        secondary={ email }
                        primaryTypographyProps={ { typography: 'body2' } }
                        secondaryTypographyProps={ {
                            component: 'span',
                            color: 'text.disabled',
                        } }
                    />
                </TableCell>

                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ "Demo" }</TableCell>
                {/* <TableCell sx={ { whiteSpace: 'nowrap' } }>{ company }</TableCell> */ }
                {/* <TableCell sx={ { whiteSpace: 'nowrap' } }>{ role }</TableCell> */ }

                <TableCell>
                    <Label
                        variant="soft"
                        color={
                            (status?.name === 'Active' && 'success') ||
                            (status?.name === 'Inactive' && 'warning') ||
                            'default'
                        }
                    >
                        { status?.name }
                    </Label>
                </TableCell>

                <TableCell align="right" sx={ { px: 1, whiteSpace: 'nowrap' } }>
                    {/* <Tooltip title="Quick Edit" placement="top" arrow>
                        <IconButton color={ quickEdit.value ? 'inherit' : 'default' } onClick={ quickEdit.onTrue }>
                            <Iconify icon="solar:pen-bold" />
                        </IconButton>
                    </Tooltip> */}

                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell>
            </TableRow>

            {/* <UserQuickEditForm currentUser={ row } open={ quickEdit.value } onClose={ quickEdit.onFalse } /> */ }

            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >
                <MenuItem
                    onClick={ () => {
                        confirm.onTrue();
                        popover.onClose();
                    } }
                    sx={ { color: 'error.main' } }
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>

                <MenuItem
                    onClick={ () => {
                        navigate("/dashboard/admin-users/new-user", { state: row });
                    } }
                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>

            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content="Are you sure want to delete?"
                action={
                    <Button variant="contained" color="error" onClick={ onDeleteRow }>
                        Delete
                    </Button>
                }
            />
        </>
    );
}

UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};
